import { getCalendarEntries, getCalendarGroups } from 'owa-calendar-cache';
import {
    updateStoreCalendarGroups,
    updateStoreCalendars,
} from 'owa-calendar-surface-calendars-store';

import { convertToCalendarType } from './convertFromCacheTypeToCalendarModuleStoreType';
import { restoreSelectedCalendars } from '../actions/restoreSelectedCalendars';

export async function refreshCalendarStoreWithCalendarCacheData(userIdentity?: string) {
    const calendars = getCalendarEntries().map(calendarEntry =>
        convertToCalendarType(calendarEntry, calendarEntry.calendarId.mailboxInfo)
    );
    const groups = getCalendarGroups();

    updateStoreCalendarGroups(groups);
    updateStoreCalendars(calendars);

    // Restore previously selected calendars
    await restoreSelectedCalendars(userIdentity);
}
